/**
 * EtVraagNav — vraagnummer-navigatie met overloop (Facet-blauwdruk §10 punt 5).
 *
 * Het echte examen heeft 23 vragen; nummerknoppen met een venster rond de
 * huidige vraag en "…" voor de rest. Kleuren volgen de overzicht-legenda:
 * gemaakt = groen, gemarkeerd = amber, actief = teal-ring.
 */
import React from 'react';
import './EtVraagNav.css';

export default function EtVraagNav({ huidig, totaal, beantwoordSet, gemarkeerdSet, onSpring, labels }) {
  // venster: altijd 1 en N; rond huidig ±2; gaten worden "…"
  const zichtbaar = new Set([0, totaal - 1]);
  for (let k = huidig - 2; k <= huidig + 2; k++) if (k >= 0 && k < totaal) zichtbaar.add(k);
  const items = [];
  let vorige = -1;
  for (let k = 0; k < totaal; k++) {
    if (!zichtbaar.has(k)) continue;
    if (vorige !== -1 && k - vorige > 1) items.push({ dots: true, key: `d${k}` });
    items.push({ idx: k, key: k });
    vorige = k;
  }
  return (
    <nav className="etn-balk" aria-label="Vraagnavigatie">
      {items.map((it) => it.dots ? (
        <span key={it.key} className="etn-dots" aria-hidden="true">…</span>
      ) : (
        <button key={it.key}
          className={`etn-nr ${it.idx === huidig ? 'actief' : ''} ${gemarkeerdSet?.has(it.idx) ? 'gemarkeerd' : beantwoordSet?.has(it.idx) ? 'gemaakt' : ''}`}
          aria-current={it.idx === huidig ? 'true' : undefined}
          aria-label={`Ga naar vraag ${labels?.[it.idx] ?? it.idx + 1}`}
          onClick={() => onSpring(it.idx)}>
          {labels?.[it.idx] ?? it.idx + 1}
        </button>
      ))}
    </nav>
  );
}
